import React from 'react'
import styled, { css } from 'styled-components'

export const BackdropWrapper = styled.div<{ size: string, mobile: boolean }>`
  ${({ size, mobile }) => {
    if (mobile) {
      return css`
      width: 30px;
      height: 24px;
      `
    }
    if (size === 'small') {
      return css`
        width: 30px;
        height: 24px;
      `
    }
    return css`
      width: 48px;
      height: 40px;
    `
  }};
  display: flex;
  justify-content: center;
  place-items: center;
  padding: 4px 8px;
  background-color: rgba(24, 26, 28, 0.5);
  border-radius: 4px;
  cursor: pointer;

  svg path {
    fill: #E7E7E7;
  }

  &:hover {
    svg path {
      fill: #fff;
    }
  }
`

export const DeleteIcon = ({ onClick, size, color = '#909090', mobile = false }: any) => (
  <BackdropWrapper onClick={onClick} size={size} mobile={mobile}>
    {mobile ? (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.07031 1.47266C6.44899 1.47266 5.94531 1.97634 5.94531 2.59766V2.97266H3.32031C2.69899 2.97266 2.19531 3.47634 2.19531 4.09766V4.84766C2.19531 5.46898 2.69899 5.97266 3.32031 5.97266H3.69531V15.3477C3.69531 15.969 4.19899 16.4727 4.82031 16.4727H13.0703C13.6916 16.4727 14.1953 15.969 14.1953 15.3477V5.97266H14.5703C15.1916 5.97266 15.6953 5.46898 15.6953 4.84766V4.09766C15.6953 3.47634 15.1916 2.97266 14.5703 2.97266H11.9453V2.59766C11.9453 1.97634 11.4416 1.47266 10.8203 1.47266H7.07031ZM11.1953 2.97266V2.59766C11.1953 2.39055 11.0274 2.22266 10.8203 2.22266H7.07031C6.86321 2.22266 6.69531 2.39055 6.69531 2.59766V2.97266H11.1953ZM5.94531 3.72266H3.32031C3.11321 3.72266 2.94531 3.89055 2.94531 4.09766V4.84766C2.94531 5.05476 3.11321 5.22266 3.32031 5.22266H3.69531H4.07031H13.8203H14.1953H14.5703C14.7774 5.22266 14.9453 5.05476 14.9453 4.84766V4.09766C14.9453 3.89055 14.7774 3.72266 14.5703 3.72266H11.9453H11.5703H6.32031H5.94531ZM4.44531 5.97266H13.4453V15.3477C13.4453 15.5548 13.2774 15.7227 13.0703 15.7227H4.82031C4.61321 15.7227 4.44531 15.5548 4.44531 15.3477V5.97266Z" fill={color} />
      </svg>
      
    ) : (
      <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.39998 2.91667C8.39998 1.85812 9.2581 1 10.3166 1H13.6833C14.7419 1 15.6 1.85812 15.6 2.91667V3.45833C15.6 3.51449 15.5976 3.57007 15.5928 3.625H20.0417C20.5709 3.625 21 4.05406 21 4.58333V7.91667C21 8.44594 20.5709 8.875 20.0417 8.875H19.1928C19.1976 8.92994 19.2 8.98553 19.2 9.0417V20.0834C19.2 21.1419 18.3419 22 17.2833 22H6.71666C5.65812 22 4.79999 21.1419 4.79999 20.0834V9.0417C4.79999 8.98553 4.80241 8.92994 4.80714 8.875H3.95833C3.42906 8.875 3 8.44594 3 7.91667V4.58333C3 4.05406 3.42906 3.625 3.95833 3.625H8.40713C8.4024 3.57007 8.39998 3.51449 8.39998 3.45833V2.91667ZM10.3166 2.91667L13.6833 2.91667V3.45833L10.3166 3.45833V2.91667ZM4.91667 5.54167V6.95833H19.0833V5.54167H4.91667ZM17.2833 9.0417H6.71666L6.71666 20.0834H17.2833L17.2833 9.0417Z'
        fill={color}
      />
    </svg>
    )}
  </BackdropWrapper>
)
import React from 'react'
import styled, { css } from 'styled-components'

export const BackdropWrapper = styled.div<{ size: string, mobile: boolean }>`
  ${({ size, mobile }) => {
    if (mobile) {
      return css`
      width: 30px;
      height: 24px;
      `
    }
    if (size === 'small') {
      return css`
        width: 30px;
        height: 24px;
      `
    }
    return css`
      width: 48px;
      height: 40px;
    `
  }};
  display: flex;
  justify-content: center;
  place-items: center;
  padding: 4px 8px;
  background-color: rgba(24, 26, 28, 0.5);
  border-radius: 4px;
  cursor: pointer;

  svg path {
    fill: #E7E7E7;
  }

  &:hover {
    svg path {
      fill: #fff;
    }
  }
`

export const DeleteIcon = ({ onClick, size, color = '#909090', mobile = false }: any) => (
  <BackdropWrapper onClick={onClick} size={size} mobile={mobile}>
    {mobile ? (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.07031 1.47266C6.44899 1.47266 5.94531 1.97634 5.94531 2.59766V2.97266H3.32031C2.69899 2.97266 2.19531 3.47634 2.19531 4.09766V4.84766C2.19531 5.46898 2.69899 5.97266 3.32031 5.97266H3.69531V15.3477C3.69531 15.969 4.19899 16.4727 4.82031 16.4727H13.0703C13.6916 16.4727 14.1953 15.969 14.1953 15.3477V5.97266H14.5703C15.1916 5.97266 15.6953 5.46898 15.6953 4.84766V4.09766C15.6953 3.47634 15.1916 2.97266 14.5703 2.97266H11.9453V2.59766C11.9453 1.97634 11.4416 1.47266 10.8203 1.47266H7.07031ZM11.1953 2.97266V2.59766C11.1953 2.39055 11.0274 2.22266 10.8203 2.22266H7.07031C6.86321 2.22266 6.69531 2.39055 6.69531 2.59766V2.97266H11.1953ZM5.94531 3.72266H3.32031C3.11321 3.72266 2.94531 3.89055 2.94531 4.09766V4.84766C2.94531 5.05476 3.11321 5.22266 3.32031 5.22266H3.69531H4.07031H13.8203H14.1953H14.5703C14.7774 5.22266 14.9453 5.05476 14.9453 4.84766V4.09766C14.9453 3.89055 14.7774 3.72266 14.5703 3.72266H11.9453H11.5703H6.32031H5.94531ZM4.44531 5.97266H13.4453V15.3477C13.4453 15.5548 13.2774 15.7227 13.0703 15.7227H4.82031C4.61321 15.7227 4.44531 15.5548 4.44531 15.3477V5.97266Z" fill={color} />
      </svg>
      
    ) : (
      <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.39998 2.91667C8.39998 1.85812 9.2581 1 10.3166 1H13.6833C14.7419 1 15.6 1.85812 15.6 2.91667V3.45833C15.6 3.51449 15.5976 3.57007 15.5928 3.625H20.0417C20.5709 3.625 21 4.05406 21 4.58333V7.91667C21 8.44594 20.5709 8.875 20.0417 8.875H19.1928C19.1976 8.92994 19.2 8.98553 19.2 9.0417V20.0834C19.2 21.1419 18.3419 22 17.2833 22H6.71666C5.65812 22 4.79999 21.1419 4.79999 20.0834V9.0417C4.79999 8.98553 4.80241 8.92994 4.80714 8.875H3.95833C3.42906 8.875 3 8.44594 3 7.91667V4.58333C3 4.05406 3.42906 3.625 3.95833 3.625H8.40713C8.4024 3.57007 8.39998 3.51449 8.39998 3.45833V2.91667ZM10.3166 2.91667L13.6833 2.91667V3.45833L10.3166 3.45833V2.91667ZM4.91667 5.54167V6.95833H19.0833V5.54167H4.91667ZM17.2833 9.0417H6.71666L6.71666 20.0834H17.2833L17.2833 9.0417Z'
        fill={color}
      />
    </svg>
    )}
  </BackdropWrapper>
)
